/** Express mode is our shared Entra sign-in app; 'azure_ad' is an admin-declared Entra IdP.
 *  Either one gets Microsoft's branded button rather than a generic SSO one. */
export function isMicrosoftIdP(result: { sso_mode?: string | null; idp_hint?: string | null }): boolean {
  return result.sso_mode === 'microsoft_express' || result.idp_hint === 'azure_ad'
}
